import { LICENSE } from '../../../constants/reading/CommonConstants';
import { FETCH_SHARED_INTERPS, FETCH_ALL_INTERPS } from '../../actionTypes/shared/apiActionTypes';
import { FETCH_READING_INTERPS } from '../../actionTypes/reading/apiActionTypes';
import { APP_LANGUAGE } from '../../../constants/shared/CommonConstants';
import SpellingClient from '../../clients/shared/SpellingClient';
import VocaboClient from '../../clients/shared/VocaboClient';
import OLClient from '../../clients/shared/OLClient';
import RANClient from '../../clients/reading/RANClient';
import TranslatorClient from '../../clients/reading/TranslatorClient';
import CompositeClient from '../../clients/reading/CompositeClient';
import MAZEClient from '../../clients/reading/MAZEClient';
import DecodingClient from '../../clients/reading/DecodingClient';
import { multyApiCallActionCreator } from '../../actionCreators';
import { selectors } from '../../../root/reading/root';

const fetchInterps = () => async (dispatch, getState) => {
    const state = getState();
    const { licensingInfo } = selectors.getCommonData(state);
    const fetchAllInterpsApiCallsConfig = {
        [FETCH_SHARED_INTERPS.VOCABO]: () =>
            licensingInfo.includes(LICENSE.VOCABO) && VocaboClient.getInterps(APP_LANGUAGE.ENGLISH),
        [FETCH_SHARED_INTERPS.OL]: () =>
            licensingInfo.includes(LICENSE.OL) && OLClient.getInterps(APP_LANGUAGE.ENGLISH),
        [FETCH_SHARED_INTERPS.SPELLING]: () =>
            licensingInfo.includes(LICENSE.SPELLING) &&
            SpellingClient.getInterps(APP_LANGUAGE.ENGLISH),
        [FETCH_READING_INTERPS.RAN]: () =>
            licensingInfo.includes(LICENSE.RAN) && RANClient.getInterps(),
        [FETCH_READING_INTERPS.D8]: () =>
            licensingInfo.includes(LICENSE.D8) && TranslatorClient.getInterps(),
        [FETCH_READING_INTERPS.D8_COMPOSITE]: () =>
            licensingInfo.includes(LICENSE.D8) && CompositeClient.getCompositeInterps(),
        [FETCH_READING_INTERPS.MAZE]: () =>
            licensingInfo.includes(LICENSE.D8) && MAZEClient.getInterps(),
        [FETCH_READING_INTERPS.DECODING]: () =>
            licensingInfo.includes(LICENSE.EXPRESS) && DecodingClient.getInterps(),
    };
    await multyApiCallActionCreator(dispatch, fetchAllInterpsApiCallsConfig, FETCH_ALL_INTERPS);
};

export default fetchInterps;
